import { render, staticRenderFns } from "./side-menu.vue?vue&type=template&id=663fe207&"
import script from "./side-menu.vue?vue&type=script&lang=ts&"
export * from "./side-menu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports